// PartnerInactiveBillDetailsComponent.jsx
import React, { useState, useEffect } from "react";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../Loading/component";
import "./PartnerInactiveBillDetails.css";
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow, Paper
} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import dayWiseData from "../../../../assests/daysWiseData.svg";
import billsummery from "../../../../assests/billsummery.svg"
import chargeicon from "../../../../assests/chargeicon.svg"
import cancel from "../../../../assests/cancel.svg"
import leftArrow from "../../../../assests/leftArrow.svg"

const PartnerInactiveBillDetailsComponent = ({ 
  loading,
  chargesLoading,
  billData, 
  payoutBillData, 
  onGoBack, 
  handleMiscCharge, 
  handlePostBill, 
  chargeSummary, 
  fetchChargeBillSummary,
  allCharges
}) => {

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCharge, setSelectedCharge] = useState(null);
  const [showDeductionDetails, setShowDeductionDetails] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [calculatedEndDate, setCalculatedEndDate] = useState("");
  const [calculatedStartDate, setCalculatedStartDate] = useState("");
  const [selectedDayIndex, setSelectedDayIndex] = useState(null);
  const [selectedPayoutId, setSelectedPayoutId] = useState(null);
  const [selectedChargeId, setSelectedChargeId] = useState(null);

  useEffect(() => {
    if (billData || payoutBillData) {
      const startDate = calculateStartDate();
      const endDate = calculateEndDate(startDate);
      setCalculatedStartDate(startDate);
      setCalculatedEndDate(endDate);
    }
  }, [billData, payoutBillData]);

  const getLastDateOfMonth = (dateString) => {
    try {
      if (!dateString || dateString === "N/A" || dateString === "null" || dateString === "undefined") {
        return "N/A";
      }
      
      let date;
      if (dateString.includes("/")) {
        const [day, month, year] = dateString.split("/").map(Number);
        date = new Date(year, month - 1, day);
      } else if (dateString.includes("-")) {
        date = new Date(dateString);
      } else {
        return "N/A";
      }
      
      if (isNaN(date.getTime())) {
        return "N/A";
      }
      
      const lastDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const formattedDay = String(lastDate.getDate()).padStart(2, "0");
      const formattedMonth = String(lastDate.getMonth() + 1).padStart(2, "0");
      const formattedYear = lastDate.getFullYear();
      
      return `${formattedDay}/${formattedMonth}/${formattedYear}`;
    } catch (error) {
      console.error("Error calculating last date of month:", error);
      return "N/A";
    }
  };

  const calculateStartDate = () => {
    if (billData?.startDate && billData.startDate !== "null" && billData.startDate !== "undefined" && billData.startDate !== "N/A") {
      return formatDisplayDate(billData.startDate);
    }
    
    if (payoutBillData?.startDate && payoutBillData.startDate !== "null" && payoutBillData.startDate !== "undefined" && payoutBillData.startDate !== "N/A") {
      return formatDisplayDate(payoutBillData.startDate);
    }
    
    return "N/A";
  };

  const calculateEndDate = (startDate) => {
    if (billData?.endDate && billData.endDate !== "null" && billData.endDate !== "undefined" && billData.endDate !== "N/A") {
      return formatDisplayDate(billData.endDate);
    }
    
    if (startDate && startDate !== "N/A") {
      const monthEndDate = getLastDateOfMonth(startDate);
      if (monthEndDate !== "N/A") {
        return monthEndDate;
      }
    }
    
    if (payoutBillData?.endDate && payoutBillData.endDate !== "null" && payoutBillData.endDate !== "undefined" && payoutBillData.endDate !== "N/A") {
      return formatDisplayDate(payoutBillData.endDate);
    }
    
    return "N/A";
  };

  const formatDisplayDate = (dateString) => {
    try {
      const date = new Date(dateString);
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'short' });
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    } catch {
      return dateString;
    }
  };

  if (loading) return <LoadingSpinner />;
  if (!billData) return <div>No bill data available.</div>;

  const handleViewClick = (charge) => {
    setSelectedCharge(charge);
    setSelectedChargeId(charge.id);
    setOpenDialog(true);
  };
  
  const totalTransactionalAmount = chargeSummary?.transactionalCharges?.reduce(
    (acc, charge) => acc + (charge.amount),
    0
  );
 
  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return '₹ 0';
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount).replace('₹', '₹ ');
  };
   
  const totalFixedAmount = chargeSummary?.fixedCharges?.reduce(
    (acc, charge) => acc + (charge.amount),
    0
  );
  
  const totalDeduction = (totalTransactionalAmount || 0) + (totalFixedAmount || 0);

  const selectedDayNetPayable = selectedDayIndex !== null && payoutBillData?.payouts?.[selectedDayIndex]
    ? payoutBillData.payouts[selectedDayIndex].netPayable || 0 
    : 0;

  const netDeduction = totalDeduction + selectedDayNetPayable;

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCharge(null);
    setSelectedChargeId(null);
  };
  
  const handleDeductionClick = (payoutId, totalDeductions, dayIndex) => {
    console.log("Clicked index:", dayIndex);
    console.log("Net payable from array:", payoutBillData?.payouts?.[dayIndex]?.netPayable);
    
    // Set the selected day index FIRST
    setSelectedDayIndex(dayIndex);
    
    if (totalDeductions >= 0) {
      fetchChargeBillSummary(payoutId);
      setShowDeductionDetails(true);
    }
  };


  const handlePrev = () => {
    setCurrentIndex(prev => Math.max(0, prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex(prev =>
      Math.min(prev + 1, Math.max(0, billData?.charges?.length - 4))
    );
  };
 
  const visibleCharges = billData?.charges?.slice(currentIndex, currentIndex + 4) || [];
  const showArrows = billData?.charges?.length > 4;

  // Get charge details from allCharges?.data array
  const getChargeDetailsById = (chargeId) => {
    if (!allCharges || !Array.isArray(allCharges)) return null;
    return allCharges.find(charge => charge.id === chargeId);
  };

  const selectedChargeDetails = getChargeDetailsById(selectedChargeId);



  const getChargeName = (chargeType, chargeId) => {
    const chargeDetail = getChargeDetailsById(chargeId);
    return chargeDetail?.name || chargeType || 'N/A';
  };
  console.log("visiblecharges",allCharges)

  return (
    <div className="partner-bill-layout">
      <Sidebar />
      <div className="partner-bill-summary">
        <div style={{ display: "flex", alignItems: "center" }}>
          <button className="back-button" onClick={onGoBack}>
            <img src={leftArrow} alt="Back" />
          </button>
          <h2 className="partner-title">
            Partner - {billData.name} (Owner ID: {billData.franchiseeId})
          </h2>
        </div>

        <div className="bill-id-banner">
          <div className="bill-id-left">
            Bill ID - <span style={{ fontWeight: 400 }}>{billData.billId}</span>
          </div>
          <div className="bill-id-left"> 
            Total VM: <span style={{ fontWeight: 400 }}>{payoutBillData?.vmCount || 0}</span>
          </div>
          <div className="bill-id-right">
            <img src={billsummery} alt="" /> 
            Start Date: <span style={{ fontWeight: 400 }}>{calculatedStartDate}</span> &nbsp; 
            End Date: <span style={{ fontWeight: 400 }}>{calculatedEndDate}</span>
          </div>
        </div>

        <div className="bill-charges-section">
          <div className="charges-header">
            <h4>Charges Applied on this Bill</h4>
            {billData.status !== 'CLOSED' && (
              <Button
                variant="outlined"
                className="add-charge-btn"
                onClick={handleMiscCharge}
              >
                Add Misc. Charge
              </Button>
            )}
          </div>

          {chargesLoading ? (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}>
              <LoadingSpinner />
            </div>
          ) : (
            <div className="charges-carousel">
              {showArrows && (
                <IconButton
                  className="carousel-arrow left-arrow"
                  onClick={handlePrev}
                  disabled={currentIndex === 0}
                >
                  <ChevronLeftIcon />
                </IconButton>
              )}

              <div className="charges-container">
                {allCharges.length > 0 ? (
                  allCharges.map((charge, i) => (
                    <div className="charge-banner" key={i}>
                      {charge.chargeType === "misc_charge" && (
                        <div className="misc-badge">M</div>
                      )}

                      <div className="charge-details">
                        <div className="charge-row">
                          <span className="charge-label">Name:</span>
                          <span className="charge-value" title={getChargeName(charge.chargeType, charge.id)}>
                            {getChargeName(charge.chargeType, charge.id)}
                          </span>
                        </div>
                        <div className="charge-row">
                          <span className="charge-label">Value:</span>
                          <span className="charge-value">{formatCurrency(charge.value)}</span>
                        </div>
                      </div>

                      <IconButton
                        className="chargeview-icon"
                        onClick={() => handleViewClick(charge)}
                      >
                        <VisibilityIcon fontSize="small" />
                      </IconButton>
                    </div>
                  ))
                ) : (
                  <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                    No charges applied on this bill
                  </div>
                )}
              </div>

              {showArrows && (
                <IconButton
                  className="carousel-arrow right-arrow"
                  onClick={handleNext}
                  disabled={currentIndex >= (billData?.charges?.length - 4)}
                >
                  <ChevronRightIcon />
                </IconButton>
              )}
            </div>
          )}
        </div>

        {/* Charge Details Dialog */}
        <Dialog
          open={openDialog}
          className="charge-dialog"
          PaperProps={{
            style: {
              borderRadius: '12px',
              padding: '20px',
              minWidth: '450px',
              maxWidth: '600px'
            }
          }}
        >
          <DialogTitle className="dialog-title" sx={{ 
            display: "flex", 
            justifyContent: "flex-start", 
            alignItems: "center", 
            gap: "12px",
            padding: '16px 24px'
          }}>
            <img src={chargeicon} alt="Charge Icon" />
            <div>
              <Typography variant="h5" style={{ fontWeight: 600, fontSize: '20px' }}>
                {selectedChargeDetails?.name || selectedCharge?.chargeType || 'Charge Details'}
              </Typography>
              <Typography variant="subtitle2" style={{ color: '#666', marginTop: '4px' }}>
                Charge ID: {selectedChargeDetails?.id || selectedCharge?.id}
              </Typography>
            </div>
          </DialogTitle>
          
          <DialogContent className="dialog-content" sx={{ padding: '16px 24px' }}>
            <div style={{ display: 'flex',flexDirection:"column"}}>
              <div className="charge-detail-item">
                <span className="detail-label">Charge Type:</span>
                <span className="detail-value" style={{ textTransform: 'capitalize' }}>
                  {selectedChargeDetails?.chargeType || selectedCharge?.chargeType || 'N/A'}
                </span>
              </div>
              
              <div className="charge-detail-item">
                <span className="detail-label">Deduction Type ID:</span>
                <span className="detail-value">
                  {selectedChargeDetails?.deductionTypeId || 'N/A'}
                </span>
              </div>

              <div className="charge-detail-item" style={{ gridColumn: 'span 2' }}>
                <span className="detail-label">Description:</span>
                <span className="detail-value">
                  {selectedChargeDetails?.description || 'No description available'}
                </span>
              </div>

              <div className="charge-detail-item">
                <span className="detail-label">Value Type:</span>
                <span className="detail-value" style={{ textTransform: 'capitalize' }}>
                  {(selectedChargeDetails?.valueType || "N/A")}
                </span>
              </div>

              <div className="charge-detail-item">
                <span className="detail-label">Value Amount:</span>
                <span className="detail-value" style={{ fontWeight: 600 }}>
                  {selectedChargeDetails?.value ? 
                    (selectedChargeDetails.valueType?.includes('percentage') ? 
                      `${selectedChargeDetails.value}` : 
                      formatCurrency(selectedChargeDetails.value)
                    ) : formatCurrency(selectedCharge?.amount)
                  }
                </span>
              </div>

              <div className="charge-detail-item">
                <span className="detail-label">Minimum Value:</span>
                <span className="detail-value">
                  {selectedChargeDetails?.valueMin ? 
                    (selectedChargeDetails.valueType?.includes('percentage') ? 
                      `${selectedChargeDetails.valueMin}` : 
                      formatCurrency(selectedChargeDetails.valueMin)
                    ) : 'Not Set'
                  }
                </span>
              </div>

              <div className="charge-detail-item">
                <span className="detail-label">Maximum Value:</span>
                <span className="detail-value">
                  {selectedChargeDetails?.valueMax ? 
                    (selectedChargeDetails.valueType?.includes('percentage') ? 
                      `${selectedChargeDetails.valueMax}` : 
                      formatCurrency(selectedChargeDetails.valueMax)
                    ) : 'Not Set'
                  }
                </span>
              </div>
            </div>
          </DialogContent>
          
          <DialogActions style={{ justifyContent: 'center', padding: '20px 24px' }}>
            <Button
              onClick={handleCloseDialog}
              variant="contained"
              style={{
                backgroundColor: '#14AE78',
                color: 'white',
                borderRadius: '8px',
                padding: '8px 32px',
                textTransform: 'none',
                fontWeight: 500
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        
        <div className="summary-section">
          <div className="summary-header">
            <h4>
              <img src={billsummery} alt="" style={{ width: "33px", height: "33px" }} /> 
              Bill Summary - <span style={{ fontSize: "14px", fontWeight: 400 }}>{calculatedStartDate}</span> 
              <span style={{ fontSize: "14px", fontWeight: 400 }}> to </span>  
              <span style={{ fontSize: "14px", fontWeight: 400 }}>{calculatedEndDate}</span>
              <span className={`status-badgepayout ${billData.status?.toLowerCase()}`}>
                {billData.status}
              </span>
            </h4>
            {billData.status !== 'CLOSED' && (
              <a className="past-bills-link" onClick={handlePostBill}>
                View Past Bills
              </a>
            )}
          </div>
          
          <div className="summary-cards">
            <div className="summary-card">
              <div>Total Gross Sale</div>
              <strong>{formatCurrency(payoutBillData?.totalGrossSale || 0)}</strong>
            </div>
            <div className="summary-card">
              <div>Total Fix Deduction</div>
              <strong>{formatCurrency(payoutBillData?.totalFixedDeductions || 0)}</strong>
            </div>
            <div className="summary-card">
              <div>Total Transactional Deduction</div>
              <strong>{formatCurrency(payoutBillData?.totalTransactionalDeductions || 0)}</strong>
            </div>
            <div className="summary-card">
              <div>Net Payout</div>
              <strong style={{ color: (payoutBillData?.totalNetPayable || 0) < 0 ? '#d32f2f' : '#2e7d32' }}>
                {formatCurrency(payoutBillData?.totalNetPayable || 0)}
              </strong>
            </div>
          </div>
        </div>

        <div className="table-section">
          <h4>
            <img src={dayWiseData} alt="" style={{ width: "33px", height: "33px" }} /> 
            Day Wise Payout Details
          </h4>
          <div className="table-wrapper-inactive">
            <table className="payout-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Settlement ID</th>
                  <th>Total Gross Sale</th>
                  <th>Net Payout</th>
                  <th>Total Deduction</th>
                </tr>
              </thead>
              <tbody>
                {payoutBillData && payoutBillData?.payouts?.length > 0 ? (
                  payoutBillData.payouts.map((day, i) => (
                    <tr key={i} style={{ 
                      backgroundColor: selectedDayIndex === i ? '#f0f7ff' : 'transparent',
                      borderLeft: selectedDayIndex === i ? '3px solid #1976d2' : 'none'
                    }}>
                      <td>{formatDisplayDate(day.date)}</td>
                      <td>{day.payoutId}</td>
                      <td>{formatCurrency(day.revenueToday || 0)}</td>
                      <td style={{ color: (day.netPayable || 0) < 0 ? '#d32f2f' : '#2e7d32' }}>
                        {formatCurrency(day.netPayable || 0)}
                      </td>
                      <td>
                        <span
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleDeductionClick(
                              day.payoutId,
                              day.netPayable < 0
                                ? day.revenueToday    
                                : day.totalDeductions, 
                              i
                            );
                          }}
                        >
                          {day.netPayable < 0
                            ? day.revenueToday       
                            : day.totalDeductions}   
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                      No payout data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        
        {/* Deduction Details Dialog */}
        <Dialog
          open={showDeductionDetails}
          maxWidth="md"
          fullWidth
          onClose={() => setShowDeductionDetails(false)}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: '16px 24px' }}>
            <DialogTitle sx={{ padding: 0 }}>
              {chargeSummary?.date ? new Date(chargeSummary.date).toLocaleDateString('en-US', { 
                month: 'long', 
                day: 'numeric', 
                year: 'numeric' 
              }) : 'N/A'}
              {selectedPayoutId && ` (Payout ID: ${selectedPayoutId})`}
            </DialogTitle>
            <IconButton onClick={() => setShowDeductionDetails(false)}>
              <img src={cancel} alt="Close" />
            </IconButton>
          </div>

          <DialogContent sx={{ padding: '0 24px 24px' }}>
            {!chargeSummary ? (
              <LoadingSpinner />
            ) : (
              <div style={{ border: "1px solid #e0e0e0", borderRadius: '8px', padding: '24px' }}>
                <div style={{ marginBottom: '24px', fontSize: '14px' }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div>
                      <strong>Partner Name</strong> – {chargeSummary?.name || 'N/A'} ({chargeSummary?.type || 'N/A'})<br />
                      <strong>Cohort ID</strong> – {chargeSummary?.cohortId || 'N/A'}
                    </div>
                    <div>
                      <strong>Partner Id</strong> – {chargeSummary?.franchiseeId || 'N/A'}<br />
                      <strong>Total VM</strong> – {chargeSummary?.vmCount || 'N/A'}
                    </div>
                  </div>
                </div>

                <h4 style={{ margin: '0 0 16px', fontSize: '16px', fontWeight: 600 }}>Charge Summary (Transactional)</h4>
                <TableContainer component={Paper} style={{ 
                  marginBottom: '24px', 
                  boxShadow: 'none', 
                  border: '1px solid #e0e0e0', 
                  borderRadius: '8px' 
                }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell style={{ fontWeight: 600, border: 'none', textAlign: "center" }}>Deduction ID</TableCell>
                        <TableCell style={{ fontWeight: 600, border: 'none', textAlign: "center" }}>Description</TableCell>
                        <TableCell align="right" style={{ fontWeight: 600, border: 'none', textAlign: "center" }}>Amount</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {chargeSummary?.transactionalCharges?.length > 0 ? (
                        chargeSummary.transactionalCharges.map((charge) => (
                          <TableRow key={`transactional-${charge.id}`}>
                            <TableCell style={{ border: 'none', textAlign: 'center' }}>{charge.id}</TableCell>
                            <TableCell style={{ border: 'none', textAlign: 'center' }}>
                              {charge.chargeType === 'raas_fee' ? 'RAAS Fee(%)' :
                               charge.chargeType === 'ps_fee' ? 'PS Fee(%)' :
                               charge.chargeType}
                            </TableCell>
                            <TableCell align="right" style={{ border: 'none' }}>
                              {formatCurrency(charge.amount)}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={3} style={{ textAlign: 'center', border: 'none', padding: '20px' }}>
                            No transactional charges
                          </TableCell>
                        </TableRow>
                      )}
                      <TableRow style={{ backgroundColor: '#fafafa' }}>
                        <TableCell colSpan={2} style={{ border: 'none', fontWeight: 600 }}>% Charge Total</TableCell>
                        <TableCell align="right" style={{ border: 'none', fontWeight: 600 }}>
                          {formatCurrency(totalTransactionalAmount || 0)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <h4 style={{ margin: '24px 0 16px', fontSize: '16px', fontWeight: 600 }}>Charge Summary (Fixed)</h4>
                <TableContainer component={Paper} style={{ 
                  boxShadow: 'none', 
                  border: '1px solid #e0e0e0', 
                  borderRadius: '8px',
                  marginBottom: '24px'
                }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell style={{ fontWeight: 600, border: 'none', textAlign: "center" }}>Deduction ID</TableCell>
                        <TableCell style={{ fontWeight: 600, border: 'none', textAlign: "center" }}>Description</TableCell>
                        <TableCell align="right" style={{ fontWeight: 600, border: 'none', textAlign: "center" }}>Amount</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {chargeSummary?.fixedCharges?.length > 0 ? (
                        chargeSummary.fixedCharges.map((charge) => (
                          <TableRow key={`fixed-${charge.id}`}>
                            <TableCell style={{ border: 'none', textAlign: 'center' }}>{charge.id}</TableCell>
                            <TableCell style={{ border: 'none', textAlign: 'center' }}>
                              {charge.chargeType === 'saas_ik' ? 'SAAS IK' :
                               charge.chargeType === 'rental_ik' ? 'Rental IK' :
                               charge.chargeType === 'misc_charge' ? 'Miscellaneous' :
                               charge.chargeType}
                            </TableCell>
                            <TableCell align="right" style={{ border: 'none' }}>
                              {formatCurrency(charge.amount)}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={3} style={{ textAlign: 'center', border: 'none', padding: '20px' }}>
                            No fixed charges
                          </TableCell>
                        </TableRow>
                      )}
                      <TableRow style={{ backgroundColor: '#fafafa' }}>
                        <TableCell colSpan={2} style={{ border: 'none', fontWeight: 600 }}>Fix Charge Total</TableCell>
                        <TableCell align="right" style={{ border: 'none', fontWeight: 600 }}>
                          {formatCurrency(totalFixedAmount || 0)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <div
                  style={{
                    marginTop: "16px",
                    fontWeight: 600,
                    fontSize: "14px",
                    backgroundColor: "#f5f5f5",
                    padding: "16px 20px",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                  }}
                >
                  <span>Total Deduction (Transactional + Fixed):</span>
                  <span style={{ color: '#d32f2f' }}>
                    {formatCurrency(
                      (chargeSummary?.totalTransactionalDeductions || 0) +
                      (chargeSummary?.totalFixedDeductions || 0)
                    )}
                  </span>
                </div>
                
                <div
                  style={{
                    marginTop: "12px",
                    fontWeight: 600,
                    fontSize: "14px",
                    backgroundColor: "#e3f2fd",
                    padding: "16px 20px",
                    borderRadius: "8px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid #1976d2"
                  }}
                >
                  <span>Net Deduction (Total Deduction + Net Payout):</span>
                  <div style={{ textAlign: 'right' }}>
                    <span style={{ color: netDeduction < 0 ? '#d32f2f' : '#2e7d32', fontWeight: 700 }}>
                      {formatCurrency(netDeduction)}
                    </span>
                    <span style={{ marginLeft: "10px", fontSize: "12px", color: "#666", fontWeight: 400 }}>
                      (Net Payout: {formatCurrency(selectedDayNetPayable)})
                    </span>
                  </div>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
};

export default PartnerInactiveBillDetailsComponent;